var noiseTexture;
function NoiseTexture() {
    this.width = 70;
    this.height = 70;
}

NoiseTexture.prototype.generateNoise = function(canvas_id, density, background='#fff') {
	
    var canvas = document.getElementById(canvas_id);
	var ctx = canvas.getContext("2d");

    // Paint the background
    ctx.fillStyle = "#ffffff";
    ctx.fillRect(0, 0, this.width, this.height);

    // Paint the noise
    this.transparentCanvas = _createNoisyImage(
        this.width, this.height, this.opacity, density,
    );
    ctx.drawImage(this.transparentCanvas, 0, 0);
};


function _createNoisyImage(width, height, opacity, density, noisyColor) {
    var canvas = document.createElement('canvas'),
        ctx, i, x, y;
    canvas.width = width;
    canvas.height = height;
    ctx = canvas.getContext('2d');
    for (i = 0; i < width * height * density / 100; i += 1) {
        x = Math.floor(Math.random() * width);
        y = Math.floor(Math.random() * height);
        op = Math.random() * opacity / 100;
        ctx.fillStyle = 'rgba(' + 51 + ', ' + 51+ ', ' + 51 + ', ' + Math.floor(Math.random() * 6) * .1  + ')';
        ctx.fillRect(x, y, 1, 1);
    }
    return canvas;
}

noiseTexture = new NoiseTexture();
noiseTexture.generateNoise("canvas_F-IF", 0);
noiseTexture.generateNoise("canvas_VVS1-2",.1);
noiseTexture.generateNoise("canvas_VS1-2",.3);
noiseTexture.generateNoise("canvas_SI1-2",.5);
noiseTexture.generateNoise("canvas_I1",.8);
noiseTexture.generateNoise("canvas_I2",2);
noiseTexture.generateNoise("canvas_I3",5);
noiseTexture.generateNoise("canvas_S-P",30);